/**
 * Shipping inbound label location. Inventory labels are 4x2 at 300 DPI.
 */

export { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";

import { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";
import { useZplPrintLocation } from "@/lib/zplPrintLocation";

export const INBOUND_ZPL_PRINTER_STORAGE_KEY = ZPL_PRINTER_STORAGE_KEYS.shippingInbound;

export const INBOUND_LABEL_SIZE = "4x2";
export const INBOUND_LABEL_DPI = 300;

export function useInboundZplPrinter(
  options?: { fetchPrintersEnabled?: boolean },
): ReturnType<typeof useZplPrintLocation> {
  return useZplPrintLocation({
    storageKey: ZPL_PRINTER_STORAGE_KEYS.shippingInbound,
    labelSize: INBOUND_LABEL_SIZE,
    dpi: INBOUND_LABEL_DPI,
    fetchPrintersEnabled: options?.fetchPrintersEnabled,
  });
}
